var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.43,
    height: 12.43,
    viewBox: "0 0 12.43 12.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_37369",
    "data-name": "Gruppe 37369",
    transform: "translate(11270 -24199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47145",
    "data-name": "Pfad 47145",
    d: "M10.715,4.5a6.215,6.215,0,1,0,6.215,6.215A6.215,6.215,0,0,0,10.715,4.5Z",
    transform: "translate(-11274.5 24194.5)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_37370",
    "data-name": "Gruppe 37370",
    transform: "translate(-0.111 0.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47146",
    "data-name": "Pfad 47146",
    d: "M15.469,15.469H16.55v3.918",
    transform: "translate(-11279.861 24188.363)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47148",
    "data-name": "Pfad 47148",
    d: "M16.488,9.141a.878.878,0,1,0,.878.878.878.878,0,0,0-.878-.878Z",
    transform: "translate(-11280.34 24191.65)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47147",
    "data-name": "Pfad 47147",
    d: "M14.625,23.906H17.6",
    transform: "translate(-11279.514 24184.459)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.6292818fa536c2b293743e6e24dbef03.svg";
export { ForwardRef as ReactComponent };